import {
	listResourceQueryDefinitions,
	viewResourceQueryDefinitions,
	createResourceMutationDefinitions,
	updateResourceMutationDefinitions,
	deleteResourceMutationDefinitions
} from '@/providers/graphql/resourceQueryDefinitions';
import gql from 'graphql-tag';

export const VEHICLES_LIST_QUERY = gql`
	query Vehicles(
		$first: Int
		$after: String
		$where: VehicleViewModelFilterInput
		$order: [VehicleViewModelSortInput!]
	) {
		vehicles(first: $first, after: $after, where: $where, order: $order) {
			nodes {
				vehicleId
				plateNumber
				vehicleTypeId
				customerId
				vehicleType {
					name
				}
				customer {
					customerId
					displayName
					isCompany
				}
				make
				model
				color
				isActive
			}
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
		}
	}
`;

export const VEHICLE_LIST_ITEM_QUERY = gql`
	query VehicleListItem($id: Ulid!) {
		vehicle(vehicleId: $id) {
			vehicleId
			plateNumber
			vehicleType {
				name
			}
			customer {
				customerId
				displayName
				isCompany
			}
			make
			model
			color
			isActive
		}
	}
`;

export const VEHICLE_QUERY = gql`
	query Vehicle($id: Ulid!) {
		vehicle(vehicleId: $id) {
			vehicleId
			plateNumber
			vehicleTypeId
			customerId
			vehicleType {
				vehicleTypeId
				name
			}
			customer {
				customerId
				displayName
				isCompany
				email
			}
			make
			model
			color
			isActive
			createdAt
			activatedAt
			deactivatedAt
			contractVehicles {
				contractId
				vehicleId
				contract {
					contractId
					beginDate
					endDate
					isActive
				}
			}
		}
	}
`;

// Separate query for references tab - lazy loaded
export const VEHICLE_REFERENCES_QUERY = gql`
	query VehicleReferences(
		$id: Ulid!
		$parkingSessionsFirst: Int = 10
	) {
		vehicle(vehicleId: $id) {
			vehicleId
			plateNumber
			customer {
				customerId
				displayName
				isCompany
				email
			}
			contractVehicles {
				contractId
				vehicleId
				contract {
					contractId
					beginDate
					endDate
					isActive
					customer {
						customerId
						displayName
						isCompany
					}
				}
			}
		}
		parkingSessions(
			first: $parkingSessionsFirst
			order: [{ entryDateTime: DESC }]
			where: { vehicleId: { eq: $id } }
		) {
			nodes {
				parkingSessionId
				entryDateTime
				exitDateTime
				status
				customer {
					customerId
					displayName
					isCompany
				}
				contract {
					contractId
				}
			}
		}
	}
`;

export const VEHICLE_TYPES_QUERY = gql`
	query VehicleTypes {
		vehicleTypes {
			vehicleTypeId
			name
		}
	}
`;

export const VEHICLE_CREATE_MUTATION = gql`
	mutation CreateVehicle($input: CreateVehicleInput!) {
		createVehicle(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const VEHICLE_UPDATE_MUTATION = gql`
	mutation UpdateVehicle($input: UpdateVehicleInput!) {
		updateVehicle(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const VEHICLE_DELETE_MUTATION = gql`
	mutation DeleteVehicle($input: DeleteVehicleInput!) {
		deleteVehicle(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

listResourceQueryDefinitions['vehicles'] = {
	document: VEHICLES_LIST_QUERY,
	dataPath: 'vehicles.nodes',
	variables: { first: 50 }
};

viewResourceQueryDefinitions['vehicles'] = {
	document: VEHICLE_QUERY,
	dataPath: 'vehicle'
};

createResourceMutationDefinitions['vehicles'] = {
	document: VEHICLE_CREATE_MUTATION,
	operation: 'createVehicle',
	getVariables: (variables: Record<string, unknown>) => ({ input: variables })
};

updateResourceMutationDefinitions['vehicles'] = {
	document: VEHICLE_UPDATE_MUTATION,
	operation: 'updateVehicle',
	getVariables: (variables: Record<string, unknown>) => ({ input: variables })
};

deleteResourceMutationDefinitions['vehicles'] = {
	document: VEHICLE_DELETE_MUTATION,
	operation: 'deleteVehicle',
	getVariables: (variables: Record<string, unknown>) => ({ input: variables })
};
